import { AllSubscriptionData, FoldersPage } from "types/subscribtios";
import { FAST_API_URL, postOptions } from "../index";

export * from "./ruSubtitleApi";
export * from "./translateApi";
export * from "./syntAudio";
export * from "./recomendations";
export * from "./forceAlignFragments";
export * from "./healthCheck";
export * from "./voiceoverV2";
export * from "./clipEditApi";
export * from "./realtimeEditor";
export * from "./streamEditorSync";
export * from "./manualOnly";

export const getFoldersApi = async (mediaId: string): Promise<FoldersPage> => {
  const response = await fetch(`${FAST_API_URL}/cnt_fls?media=${mediaId}`);
  if (!response.ok) {
    throw new Error("cant get folders");
  }
  return await response.json();
};

export const getAllDataForEditingApi = async ({
  mediaId,
  lang,
  languageFrom,
}: {
  mediaId: string;
  lang: string;
  languageFrom?: string;
}): Promise<AllSubscriptionData[]> => {
  let url = `${FAST_API_URL}/get_all_data_for_editing?media=${mediaId}&lang=${lang}`;
  if (languageFrom) {
    url += `&language_from=${languageFrom}`;
  }
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("cant get all data for Editing");
  }
  return await response.json();
};

export const validateDataCompleteness = async ({
  mediaId,
  lang,
  languageFrom,
  folder,
}: {
  mediaId: string;
  lang: string;
  languageFrom: string;
  folder?: number;
}): Promise<any> => {
  const response = await fetch(`${FAST_API_URL}/validate_data_completeness?media=${mediaId}`, {
    ...postOptions,
    body: JSON.stringify({ lang, language_from: languageFrom, folder }),
  });
  if (!response.ok) {
    throw new Error("cant validate data completeness");
  }
  return await response.json();
};

export const getProjectDataApi = async (mediaId: string): Promise<any> => {
  const response = await fetch(`${FAST_API_URL}/get_project_data?media=${mediaId}`);
  if (!response.ok) return null;
  return await response.json();
};

export const checkEmptySpots = async ({
  mediaId,
  lang,
  languageFrom,
  folder,
  endFolder,
  minDurationSec = 5.0,
}: {
  mediaId: string;
  lang: string;
  languageFrom: string;
  folder?: number;
  endFolder?: number;
  minDurationSec?: number;
}): Promise<any> => {
  const response = await fetch(`${FAST_API_URL}/check_empty_spots?media=${mediaId}`, {
    ...postOptions,
    body: JSON.stringify({
      lang,
      language_from: languageFrom,
      folder,
      end_folder: endFolder,
      min_duration_sec: minDurationSec,
    }),
  });
  if (!response.ok) {
    throw new Error("cant check empty spots");
  }
  return await response.json();
};

export const approveEmptySpot = async ({
  mediaId,
  lang,
  folder,
  startTime,
  duration,
}: {
  mediaId: string;
  lang: string;
  folder: number;
  startTime: number;
  duration: number;
}): Promise<any> => {
  const response = await fetch(`${FAST_API_URL}/approve_empty_spot?media=${mediaId}`, {
    ...postOptions,
    body: JSON.stringify({
      lang,
      folder,
      start_time: startTime,
      duration,
    }),
  });
  if (!response.ok) {
    throw new Error("cant approve empty spot");
  }
  return await response.json();
};

export const unapproveEmptySpot = async ({
  mediaId,
  lang,
  folder,
  startTime,
  duration,
}: {
  mediaId: string;
  lang: string;
  folder: number;
  startTime: number;
  duration: number;
}): Promise<any> => {
  const response = await fetch(`${FAST_API_URL}/unapprove_empty_spot?media=${mediaId}`, {
    ...postOptions,
    body: JSON.stringify({
      lang,
      folder,
      start_time: startTime,
      duration,
    }),
  });
  if (!response.ok) {
    throw new Error("cant unapprove empty spot");
  }
  return await response.json();
};


